import dayjs from 'dayjs';
import advancedFormat from 'dayjs/plugin/advancedFormat';
import duration from 'dayjs/plugin/duration';
import { TimeStamp } from '../types/GameplayTypes';

dayjs.extend(advancedFormat);
dayjs.extend(duration);

export function friendlyDateString(args: { millis: TimeStamp; }) {
	return dayjs(args.millis).format('ddd, MMM Do, YYYY');
}